<template>
  <div class="content-bd">
    <div class="content-left">
      <section class="practice">
        <header class="section-hd">
          <span class="section-title-l"></span>
          <h2 class="section-title">项目经历</h2>
          <span class="section-title-r"></span>
        </header>
        <div class="section-bd">
          <!--经历-->
          <div class="item">
            <header class="item-hd">
              <h3 class="item-name"> 成都创立信息科技有限公司</h3>
              <span class="item-time">2020.04 至 2022.03</span>
              <a class="btn item-more" href="#" title="">工作</a>
            </header>

          

            <!-- <ol class="item-project">
              <li class="project-1">
                <h3 class="project-name">
                  <a href="#"  title=""></a>
                </h3> -->

                <ol class="item-project">
                  <li class="project-1">
                    <div class="item-bd">
                      <h3 class="project-name">项目名称</h3>
                      <div class="div-item">
                        <h3 class="project-des">【项目简介】</h3>
                        <p class="item-project-des">
                          该项目为等多项服务组成。
                        </p>
                      </div>
                      <div class="div-item">
                        <h3 class="project-des">【工作职责】</h3>
                        <ul class="section-content">
                          <li>
                            负责项目框架搭建以及疑难问题解决，为项目成员提供开发思路
                          </li>
                         
                        </ul>
                      </div>
                    </div>
                  </li>

                  <li class="project-1">
                    <div class="item-bd">
                      <h3 class="project-name">项目名称</h3>
                      <div class="div-item">
                        <h3 class="project-des">【项目简介】</h3>
                        <p class="item-project-des">
                          该项目前端开发框架采用目前市面流行的Vue.js框架与Element
                          UI 2.0。采用websocket、TradingView、vuex等技术栈
                        </p>
                      </div>
                      <div class="div-item">
                        <h3 class="project-des">【工作职责】</h3>
                        <ul class="section-content">
                          <li>
                            负责项目框架搭建以及疑难问题解决，为项目成员提供开发思路
                          </li>
                          <li>
                            主导整个项目正常开发流程，研究K线渲染组件TradingView的使用与原理
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>                
                </ol>

              <!-- </li>                   
            </ol> -->

          </div>

          <!--经历-->
          <div class="item">
             <header class="item-hd">
              <h3 class="item-name">纬创软件</h3>
              <span class="item-time">2019.06 至 2020.03</span>
              <a class="btn item-more" href="#" title="">工作</a>
            </header>

           <!-- <ol class="item-project">
              <li class="project-1">
                <h3 class="project-name">
                  <a href="#"  title=""></a>
                </h3> -->

                <ol class="item-project">
                  <li class="project-1">
                    <div class="item-bd">
                      <h3 class="project-name">项目名称</h3>
                      <div class="div-item">
                        <h3 class="project-des">【项目简介】</h3>
                        <p class="item-project-des">
                          该项目为等多项服务组成。
                        </p>
                      </div>
                      <div class="div-item">
                        <h3 class="project-des">【工作职责】</h3>
                        <ul class="section-content">
                          <li>
                            负责项目框架搭建以及疑难问题解决，为项目成员提供开发思路
                          </li>                     
                        </ul>
                      </div>
                    </div>
                  </li>              
                </ol>

              <!-- </li>       
            </ol>     -->

    </section>
  </div>


    <div class="content-right">
      <section class="skill">
        <header class="section-hd">
          <span class="section-title-l"></span>
          <h2 class="section-title">技能</h2>
          <span class="section-title-r"></span>
        </header>
        <div class="section-bd">
          <!--技能:WEB后端开发-->
          <div class="item">
            <header class="item-hd">
              <span class="item-time">WEB后端开发</span>
              <a class="btn item-more">熟练掌握</a>
            </header>
            <div class="item-bd">
              <ul class="section-content">
                <li>
                  两年后端应用Java掌握Java面向对象思想编程
                </li>
                <li>
                  熟练使用Spring Boot、SpringMVC等主流框架，熟悉Restful
                  风格API设计
                </li>

                <li>熟练使用Jwt等用户鉴权产品</li>
                <li>熟悉API开发基本流程，熟悉Restful 风格API设计</li>

                <li>
                  了解Spring cloud，正学习Spring
                  cloud在企业大型应用中的应用，以及大型应用的微服务化及服务治理知识学习
                </li>
              </ul>
            </div>
          </div>

          <!-- -->
          <div class="item">
            <header class="item-hd">
              <span class="item-time">数据库</span>
              <a class="btn item-more">熟练掌握</a>
            </header>
            <div class="item-bd">
              <ul class="section-content">
                <li>熟悉关系型数据库技术，熟练使用关系型数据库Mysql、Oracle</li>
                <li>
                  熟悉非关系型数据库技术，熟练使用非关系型数据库Nosql：Redis
                </li>
                <li>
                  熟练使用Hibernate JPA，了解 MyBatis、JDBC等数据库操作框架使用
                </li>
                <li>
                  了解分布式数据库及Mycat中间件，并正致力于提高分布式数据库能力和对于数据库高并发高可用的知识储备
                </li>
              </ul>
            </div>
          </div>

          <!-- -->
          <div class="item">
            <header class="item-hd">
              <span class="item-time">服务器|架构</span>
              <a class="btn item-more">熟练掌握</a>
            </header>
            <div class="item-bd">
              <ul class="section-content">
                <li>..</li>
              </ul>
            </div>
          </div>

          <!-- -->
          <div class="item">
            <header class="item-hd">
              <span class="item-time">开发</span>
              <a class="btn item-more">掌握</a>
            </header>
            <div class="item-bd">
              <ul class="section-content">
                <li>
                  ....
                </li>
              </ul>
            </div>
          </div>

          <!--Golang-->
          <div class="item">
            <header class="item-hd">
              <span class="item-time">Golang</span>
              <a class="btn item-more">熟悉</a>
            </header>
            <div class="item-bd">
              <ul class="section-content">
                <li>熟悉Golang基本语法与标准库</li>
                <li>用Golang开发过小型项目服务</li>
              </ul>
            </div>
          </div>

         
      </section>

      <!--开源项目-->
      <!-- <section class="project">
        <header class="section-hd">
          <span class="section-title-l"></span>
          <h2 class="section-title">开源项目</h2>
          <span class="section-title-r"></span>
        </header>
        <div class="section-bd">
          以下是我的开源项目与学习总结
          <div class="item">
            <header class="item-hd">博客 | 笔记仓库</header>
            <div class="item-bd">
              <ul>
                <li>
                  <a href="http://www.gangblog.xyz" target="_blank"
                    >个人网站主页 - http://www.gangblog.xyz</a
                  >
                </li>

                <li>
                  <a href="http://doc.gangblog.xyz" target="_blank"
                    >笔记仓库 - http://doc.gangblog.xyz</a
                  >
                </li>
                <li>
                  <a href="http://www.github.com/cresentboy" target="_blank"
                    >Github - https://www.github.com/cresentboy</a
                  >
                </li>
                
              </ul>
            </div>
          </div>  
        </div>
      </section> -->
   

      <!--致谢-->
      <section class="thanks">
        <header class="section-hd">
          <span class="section-title-l"></span>
          <h2 class="section-title">致谢</h2>
          <span class="section-title-r"></span>
        </header>
        <div class="section-bd">
          <div class="item">
            <h2 style="font-weight: bold;line-height: 24px;margin-top: 10px">
              感谢您在百忙之中阅读这份履历
            </h2>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "Content",
  components: {},
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  },
  mounted() {
    $(document).ready(function() {
      if ($("ol:first").css("list-style-type") == "none") {
        /* For IE6/7 only. */
        $("ol ol").each(function(i, ol) {
          ol = $(ol);
          var level1 = ol.closest("li").index() + 1;
          ol.children("li").each(function(i, li) {
            li = $(li);
            var level2 = level1 + "." + (li.index() + 1);
            li.prepend("<span>" + level2 + "</span>");
          });
        });
      }
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/content.vue